import { CSSClasses } from "./utilsCSS";

export const EVENT_NAMES = {
  ENTER: "Enter",
  INSERT: "Insert",
  DELETE: "Delete",
  ESCAPE: "Escape",
  ARROWUP: "ArrowUp",
  ARROWDOWN: "ArrowDown",
  TAB: "Tab",
  BACKSPACE: "Backspace",
};

export const NOTIFY_TYPES = {
  WARNING: "warning",
  SUCCESS: "success",
  ERROR: "error",
  INFO: "info",
};

export const MASK = {
  PEDIMENTO_ZERO: "00-00-0000-0000000",
  PEDIMENTO: "##-##-####-#######",
  NUMERO: "###0",
  NUMERO10: "#########0",
  TIPO_CAMBIO: "##,##0.00###",
  FRACCION: "#########0",
  PERIODO: "000000",
  MANIFESTACION: "############################",
};

export const DATAGRID_HEIGHT = {
  CATALOGO: "80vh",
  CATALOGO_TAB: "70vh",
  ONLY_HEADER: "30rem",
  HEADER_TAB: "45vh",
};

export const CHARTS = {
  WIDTH: "auto",
  HEIGHT: 320,
};

export const TEXTBOX_ATTR = {
  AUTOCOMPLETE: { autoComplete: "new-password" },
  TOOLTIP_ON_DISABLED: { pointerEvents: "auto" },
  UPPERCASE: { style: "text-transform: uppercase" },
};

export const TEXTAREA_ATTR = {
  BOLD_TEXT: { class: CSSClasses.TEXTAREA_BOLD },
};

export const COMMON_ATTR = {
  TOOLTIP_ON_DISABLED: { pointerEvents: "auto" },
  COLOR_DISABLED: "#f0f3f7",
  REMOVE_FOCUS_TAB: -1,
};

export const POPUP_DEFAULT_PROPS = {
  height: "auto",
  maxHeight: "90vh",
  dragEnabled: false,
};

export const RESPONSIVE_COLUMNS = {
  Contribucion: { col: 12, sm: 12, md: 3, lg: 2, xl: 2 },
  DateBox: { col: 6, sm: 4, md: 3, lg: 2, xl: 2 },
  Operacion: { col: 6, sm: 4, md: 3, lg: 2, xl: 2 },
  Pedimento: { col: 6, sm: 4, md: 4, lg: 3, xl: 2 },
  SelBoxEstatus: { col: 6, sm: 3, md: 2, lg: 2, xl: 2 },
  TipoDoc: { col: 6, sm: 2, md: 2, lg: 2, xl: 1 },
  TxtEstatus: { col: 6, sm: 2, md: 2, lg: 2, xl: 1 },
  TxtFactura: { col: 6, sm: 8, md: 4, lg: 3, xl: 2 },
  TxtFraccion: { col: 6, sm: 3, md: 3, lg: 2, xl: 2 },
  TxtHTS: { col: 6, sm: 4, md: 3, lg: 2, xl: 2 },
  TxtOperacion: { col: 6, sm: 3, md: 3, lg: 2, xl: 2 },
  TxtPais: { col: 6, sm: 2, md: 2, lg: 1, xl: 1 },
  TxtPartida: { col: 6, sm: 2, md: 1, lg: 1, xl: 1 },
  TxtPedimento: { col: 6, sm: 4, md: 3, lg: 2, xl: 2 },
  TxtProveedor: { col: 6, sm: 4, md: 3, lg: 2, xl: 2 },
  TxtRegimen: { col: 6, sm: 3, md: 2, lg: 1, xl: 1 },
  TxtTipoDoc: { col: 6, sm: 2, md: 2, lg: 1, xl: 1 },
  TxtTipoFac: { col: 6, sm: 4, md: 2, lg: 1, xl: 1 },
  TxtTratado: { col: 6, sm: 3, md: 3, lg: 2, xl: 2 },
  TxtUM: { col: 6, sm: 2, md: 2, lg: 2, xl: 1 },
};

export const FORMAT = {
  CANTIDAD_BULTOS: "##,###,##0",
  CANTIDAD_UMC: "##,###,###,###,##0.0000",
  CANTIDAD_UMC2: "###,###.0000",
  CANTIDAD_UMC3: "###,###,###,##0.000",
  CANTIDAD_UMC4: "###,###,###,###.###",
  CANTIDAD_UMC5: "#,###,###,###,##0.0000",
  CANTIDAD_UMC6: "#,###.0000",
  CANTIDAD_UMT: "##,###,###,###,##0.0000",
  CANTIDAD_UMT2: "###,###,###,##0.00000",
  CANTIDAD_UMT3: "###,###,###,###.###",
  CANTIDAD_UMT4: "###,###,###,##0.000",
  CANTIDAD_UMT5: "#,##0.00000",
  CANTIDAD_UMT6: "#,###,###,###,##0.0000",
  CANTIDAD: "##,###,###,###,##0.0000",
  CANTIDAD2: "#0.00",
  CANTIDAD3: "###,###,##0.0000",
  CANTIDAD4: "###,###,###,##0.0000",
  CANTIDAD5: "###,###,##0.00",
  CANTIDAD6: "###,###,###,##0.000000000",
  CANTIDAD7: "##,###,###,##0.00#",
  CANTIDAD8: "###,###,##0.000000000",
  COSTO_PACKING: "##0.0000",
  COSTO_UNITARIO: "#,###,##0.000000000",
  COSTO_UNITARIO2: "##,###,##0.000000000",
  COSTO: "##,###,##0.0000#####",
  COSTO2: "$###,##0.000000",
  COSTO3: "$###,###,##0",
  DECIMAL: "decimal",
  FACTOR: "#####0.########",
  FACTOR2: "###0.0000000000",
  FACTOR3: "###,###.######",
  FACTOR4: "###,##0.000000",
  FECHA_HORA: "dd/MMM/yyyy HH:mm:ss",
  FECHA: "dd/MMM/yyyy",
  FRACCION: "##########",
  MONEDA: "#,##0.000000000",
  MONEDA2: "###0.00000",
  MONEDA3: "#,##0.00000",
  MONEDA4: "#,###.0000",
  NUMERO: "###0",
  NUMERO2: "#####0",
  NUMERO3: "##,##0",
  NUMERO4: "###,##0",
  NUMERO5: "#,###",
  NUMERO6: "#0.0000",
  PORCENTAJE: "##0.000000",
  PORCENTAJE2: "##0.0000",
  PORCENTAJE3: "#0.0000'%'",
  PORCENTAJE4: "##0.000000'%'",
  SALDO: "##,###,###,###,##0.0000",
  SALDO2: "###,###,###,##0.0000",
  SALDO3: "$###,###,###,##0.0000",
  TASA: "##0.00",
  TASA2: "##0.000",
  TASA3: "###,##0.00000",
  TASA4: "###,###.#####",
  TOTAL: "###,###,###,##0.0000",
  TOTAL2: "#,###,###,###,###,##0.00",
  TOTAL3: "#############0.00",
  TOTAL4: "#,###,###,##0.00",
  TOTAL5: "##,###,###,###,##0",
  VALOR: "##,###,###,###,##0.00",
  VALOR10: "###,###,##0.0000#####",
  VALOR11: "##,###,##0.0000#####",
  VALOR12: "###,###,###,##0.##",
  VALOR13: "#,###,###,###.##",
  VALOR14: "#,###,###,##0.00000",
  VALOR15: "####,###,###,##0.0000##",
  VALOR16: "##,##0.0000",
  VALOR2: "$###,###,###,##0.0000",
  VALOR3: "$##,###,###,###,##0.0000",
  VALOR4: "###,###.0000",
  VALOR5: "##,###,###,###,##0.0000",
  VALOR6: "#,##0.00",
  VALOR7: "###,###,###,##0.00",
  VALOR8: "###,###,###,##0.0000##",
  VALOR9: "#,##0.00",
  ZERO: "{0}",
};

export const PLOOKUP_KEYS = {
  ADUANAS: "AduanasLookup",
  BULTOS: "bultosLookup",
  CFGCONFIG: "cfgconfigLookup",
  CFGCONFIGENTIDADES: "cfgconfigEntidadesLookup",
  CLASES: "clasesLookup",
  CONFIG_FACTURA: "configuracionFacturaLookup",
  CONTRIB: "contribucionLookup",
  EMANDRIVERS: "emandriversLookup",
  EMANEQ: "emaneqLookup",
  ENTRY: "entryLookup",
  EXPORTH: "exporthLookup",
  FTAITEM: "ftaitemLookUp",
  HTS: "htsLookup",
  IDENTIFICADORES: "identificadoresLookup",
  IMPORTH: "importhLookUp",
  ITEM_VENDOR: "ItemMasterItemmVendor",
  ITEM: "ItemMasters",
  ITEM405: "ItemMastersAaudi405Lookup",
  MVH: "ManifestacionValorHLookup",
  PAISES: "paisesLookup",
  PAISTRATADO: "PaisesPorTratadoLookup",
  PATENTES: "patentesLookup",
  PEDIMENTOSH: "pedimentosLookup",
  PEDSAAI: "pedSaaiLookUp",
  PERIODOA31: "T31DscpLookup",
  PERIODOADS: "SatdscfgAnioPeriodoLookUp",
  PERMISOSH: "permisoshLookUp",
  PLANTAS: "PlantasLookup",
  PLANTASTRASLADO: "TrasladosPlantasLookup",
  PREFERENCIAS: "preferenciasLookup",
  PRFTRACK: "preferenciasTrackLookup",
  REMEDYCFG: "lookUpRemedyCfg",
  REPRESENTANTES: "responsablesLookup",
  SOLCERTH: "SolcerthLookup",
  SOLCERTIMAGE: "certificadosLookup",
  T303101: "t303101Lookup",
  TARIFA: "tarifasLookup",
  TCAMBIOS: "tiposcambioLookup",
  TIPO_VENDCUST: "VendcustByTipoLookup",
  TIPOSDOC: "DocumentosLookup",
  TIPOSFACTURA: "tiposfacturaLookup",
  TIPOSPERM: "LookUpPermTipo",
  TRASLADOSPLANTAS: "TrasladosPlantasLookup",
  UMSAAI: "umSaaiLookup",
  UNIMEDIDA: "unimedidaLookup",
  USUARIOS: "cfgUsersLookup",
  PERIODO_ANIO: "SatdscfgAnioPeriodoLookUp",
};

export const COLUMN_CONFIG = {
  KEEP_ONLY_FILTER: {
    allowFiltering: false,
    allowHeaderFiltering: true,
  },
};

export const defaultFilterOperationsNumeric = ["=", "<>", "<", ">", "<=", ">=", "between"];

export const CUSTOM_FILTERS_NUMERIC_COLUMN = {
  filterOperations: defaultFilterOperationsNumeric,
  selectedFilterOperation: "contains",
};

export const FILE_UPLOADER_TYPE_EXCEL = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel";

export const FILE_SAVE_AS_EXCEL = "data:application/vnd.ms-excel;charset=utf-8; base64,";

export const TIME_FOR_INITIAL_FOCUS = 2000;

export const BG_COLOR_TOTALES = "#dae6f7";

export const GRID_AUTO_EXEC = {
  Off: "Off",
  Top: "Top",
  All: "All",
};

export const TITLE_TABS_DEFAULT = "GlobalTrade XXI";

export const JOB_STATUS = {
  SUCCEEDED: "Succeeded",
  PROCESSING: "Processing",
  ENQUEUED: "Enqueued",
};
